import VueX from '@/store';
const LogisticOperator = () => import('@/modules/logisticOperator');

export default [
  {
    path: '/franquia/config/operadores-logisticos/:id',
    name: 'logistic-operator',
    component: LogisticOperator,
    props: true,
    meta: {
      navbarTitle: () => VueX.getters['logisticOperator/actual'].name,
    },
  },
];
